module.exports = __webpack_public_path__ + "assets/img/lianghua.d763c938.png";